module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TR-27de2e845ea0bb65b9c71d251085e1f7.png";